module.exports = require("dotenv/config");